import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SupplierInventory from '../../components/blocks/SupplierInventory';
import Spinner from '../../components/common/Spinner';
import Toolbar from '../../components/common/Toolbar';
import ActionButton from '../../components/common/ActionButton';
import InventoryHistoryLogModal from '../../components/modals/InventoryHistoryLogModal';

import {
  getSupplierInventory,
  setSupplierInventoryOffset,
  setSupplierInventoryPerPage,
  setSupplierInventoryOrderField,
  setSupplierInventoryOrder,
  setSupplierInventorySearch,
  setSupplierInventoryCurrentFilter,
} from '../../store/actions/supplierInventory';

import {
  getInventoryHistoryLog,
  setInventoryHistoryVariant,
  setInventoryHistoryOffset,
  inventoryHistoryToggleModal,
} from '../../store/actions/historyLog';

import { exportProducts } from '../../store/actions/products';
import { setProductFiltersSearch } from '../../store/actions/productFilters';
import { getSupplierProductFilters } from '../../store/actions/suppliers';

function SupplierInventoryContainer(props) {
  const { getSupplierInventory, getSupplierInventoryFilters, exportProducts, historyLog } = props;

  useEffect(() => {
    getSupplierInventory();
    getSupplierInventoryFilters();
  }, [getSupplierInventory, getSupplierInventoryFilters]);

  const openHistoryLogModal = (variant) => {
    props.historyLogSetVariant(variant);
    props.getInventoryHistoryLog();
  };
  function closeHistoryLogToggleModal() {
    props.historyLogToggleModal(false);
  }
  return props.isLoading ? (
    <Spinner />
  ) : (
    <div>
      <Toolbar name="Inventory">
        <ActionButton type="export" title="Export" onClick={exportProducts} size={22} />
      </Toolbar>

      <SupplierInventory {...props} onOpenHistoryLog={openHistoryLogModal} />

      {historyLog.open && (
        <InventoryHistoryLogModal
          {...historyLog}
          onClose={closeHistoryLogToggleModal}
          setPage={props.historyLogSetPage}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  const { data, count, perPage, search, offset, isLoading, isLoadingProducts } = state.supplierInventory;

  const { filters, currentFilters, currentFilterSearches, orderField, order } = state.productFilters;

  return {
    data,
    count,
    perPage,
    offset,
    isLoading,
    isLoadingProducts,
    searchQuery: search ?? '',
    filters,
    currentFilters,
    currentFilterSearches,
    orderField,
    order,
    historyLog: state.historyLog,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getSupplierInventory: () => dispatch(getSupplierInventory()),
  getSupplierInventoryFilters: () => dispatch(getSupplierProductFilters()),
  setPage: (offset) => dispatch(setSupplierInventoryOffset(offset)),
  setPerPage: (perPage) => dispatch(setSupplierInventoryPerPage(perPage)),
  setOrderField: (field) => dispatch(setSupplierInventoryOrderField(field)),
  setOrder: (order) => dispatch(setSupplierInventoryOrder(order)),
  setFilter: (filter) => dispatch(setSupplierInventoryCurrentFilter(filter)),
  setFilterSearch: (filter, search) => dispatch(setProductFiltersSearch(filter, search)),
  productSearch: (search) => dispatch(setSupplierInventorySearch(search)),
  exportProducts: () => dispatch(exportProducts()),
  getInventoryHistoryLog: (variant) => dispatch(getInventoryHistoryLog(variant)),
  historyLogSetVariant: (variant) => dispatch(setInventoryHistoryVariant(variant)),
  historyLogToggleModal: (open) => dispatch(inventoryHistoryToggleModal(open)),
  historyLogSetPage: (offset) => dispatch(setInventoryHistoryOffset(offset)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SupplierInventoryContainer);

SupplierInventoryContainer.defaultProps = {};

SupplierInventoryContainer.propTypes = {
  setPage: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  setFilter: PropTypes.func,
  setFilterSearch: PropTypes.func,
  productSearch: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
